import type Cookies from "js-cookie";

export const COOKIE_SERVICE = "CookieService";

/** Atributos aceitos ao gravar um cookie (derivado de `Cookies.set`). */
export type CookieAttributes = NonNullable<Parameters<typeof Cookies.set>[2]>;
